import { useCallback } from 'react';
import { Control, Controller, ControllerRenderProps, FieldErrors, get } from 'react-hook-form';
import { FormControl, FormHelperText } from '@material-ui/core';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import styles from './PhoneFlagInput.module.scss';

interface IProps {
  control: Control<any>;
  name: string;
  errors: FieldErrors;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  onInputBlur?: (data: string) => void;
  setValue: (name: any, value: any) => void;
}

const PhoneFlagInput = ({
  control,
  errors,
  name,
  onInputBlur = () => {},
  label,
  required = false,
  disabled = false,
  setValue,
}: IProps) => {
  const error = get(errors, `${name}.message`, '');

  const onChange = useCallback(
    (
      value: string,
      countryData: CountryData | Record<string, never>,
      field: ControllerRenderProps,
    ) => {
      field.onChange(value === '' || value === countryData.dialCode ? null : value);
      setValue(`${name}_countryData`, countryData);
    },
    [name, setValue],
  );

  return (
    <Controller
      control={control}
      name={name}
      rules={required ? { required: true } : undefined}
      render={({ field }) => (
        <FormControl required={required} component="fieldset" className={styles.phoneControl}>
          <PhoneInput
            country="us"
            regions={['north-america', 'europe']}
            value={field.value || ''}
            disabled={disabled}
            specialLabel={label}
            onChange={(value, countryData) => onChange(value, countryData, field)}
            onBlur={() => onInputBlur?.(field.value)}
          />
          {error && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default PhoneFlagInput;
